import React from "react";
import { observer } from "mobx-react";
import { DATE_FILTER_LIST } from "../../ReportsModule/constants";

const DateFilter = observer(({ activeFilter, onSelect }) => {
  return (
    <div className="dateFilter">
      {DATE_FILTER_LIST?.length &&
        DATE_FILTER_LIST.map(item => {
          const { name = "", id = "", value = "" } = item || {};
          return (
            item?.name !== "Custom" && (
              <div
                className={`tabItem ${activeFilter === value ? "active" : ""}`}
                id={id}
                key={id}
                onClick={() => onSelect(value)}
              >
                <span>{name}</span>
              </div>
            )
          );
        })}
    </div>
  );
});

export default DateFilter;
